export function isCustomTable(modelType) {
  if (!modelType) return false;
  const base = modelType.split(":")[0];
  return base === "CustomTable" || base === "custom_table";
}
